import { mergeRegister } from '@lexical/utils';
import { $getSelection, COMMAND_PRIORITY_HIGH, LexicalEditor, PASTE_COMMAND } from 'lexical';
import { removeZeroWidthSpace, replaceNonBreakingSpaces } from 'utils/chars';

export const normalizePasteWhitespace = (text: string): string => {
  let plainText = text
    .split('\n')
    .map(line => line.trim())
    .filter(line => line)
    .join('\n');

  plainText = removeZeroWidthSpace(replaceNonBreakingSpaces(plainText));

  return plainText;
};

export const registerCommands = (
  editor: LexicalEditor,
): () => void => {
  return mergeRegister(
    editor.registerCommand<ClipboardEvent>(
      PASTE_COMMAND,
      (event) => {
        const clipboardData = event.clipboardData;
        if (!clipboardData) {
          return false;
        }
        const plainText = normalizePasteWhitespace(clipboardData.getData('text/plain'));
        if (!plainText) {
          return false;
        }
        const selection = $getSelection();
        if (!selection) {
          return false;
        }
        selection.insertText(plainText);
        event.preventDefault();

        return true;
      },
      COMMAND_PRIORITY_HIGH,
    ));
};

